import { Injectable,EventEmitter } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { NotifierService } from 'angular-notifier';
import { Observable } from 'rxjs';
import { ApiRequestService } from 'src/app/services/api-request/api-request.service';

@Injectable({
  providedIn: 'root'
})
export class TrinityService {
  public isOpen: boolean = false;
  public isLoading: boolean = false;
  public trinityDashHeader:any = [];
  public trinityDashData:any = [];
  public page:number = 1;
  public pageSize:number = 20;
  public trinityQuoteSavePayloadObject:any = {};
  public trinityQuoteSavePrevPayloadObject:any ="";
  public trinityQuoteSaveId:any = "";
  public trinityQuoteRequestId:any = "";
  public trinityQuoteSaveName:any = "";
  public trinityWidgetData:any = [];
  public trinityWidgetDataMinMize:boolean = true;
  public isTrinityTableShow:boolean = false;
  public trinityListPage:number = 1;
  public trinityListTotalPage:number = 1;
  public isPMFeasibilty:boolean = false;
  public dataSaving:boolean = false;
  public showDataSaving:boolean = false;
  public isShowDownload:boolean = true;
  public trinityUUid:string = "";
  public tid:string = "";
  public searchText:string = "";
  public headerSearchEvent = new EventEmitter<any>();
  public isGlobalSearchShow:boolean=false;


  constructor(
    private apiRequest: ApiRequestService,
    public notify:NotifierService,
    private router: Router,
    private activaterRoute:ActivatedRoute
    
  ) { }


  toggletrinityWidgetData(){
    this.trinityWidgetDataMinMize = !this.trinityWidgetDataMinMize;
  }

  trinityDashboardDataApiCall(query?):Observable<any> {
    let opt = {};
    if(query)opt['query'] = query;
    return this.apiRequest.request('GET','/v2/trinity/quote',{},opt);
  }

  downloadQuote(body): Observable<any> {
    return this.apiRequest.request('POST','/v2/trinity/quoteDownload',body);
  }

  // downloadQuote(params: any) {
  //   return this.http.post('/api/download-excel', params, {
  //     responseType: 'blob', // Specify the response type as Blob
  //   });
  // }
  
  applyDiscount(body): Observable<any> {
    return this.apiRequest.request('POST','/v2/trinity/discountApply',body);
  }
  getTrinityDashboardData(query?){
    this.trinityDashboardDataApiCall(query).subscribe((res:any) =>{
      if(res && res.status){
        this.setHeaders(res.headers);
        this.trinityListPage = Number(res.page);
        this.trinityListTotalPage = res.total_page;
        if (this.trinityListPage == 1) {
          this.trinityDashData = res.data;
        }else{
          this.trinityDashData = [...this.trinityDashData,...res.data];
        }
        
      }else{
        this.notify.notify('error',res.message);

      }
      
    });
  }

  setHeaders(header){
    this.trinityDashHeader = [];
    Object.keys(header).forEach((key) => {
      this.trinityDashHeader.push({'label':header[key]['label'],'key':key});
    });
    // console.log(this.trinityDashHeader);
  }

  getQuoteForm(): Observable<any> {
    return this.apiRequest.request('GET','/v2/trinity/quote/form');
  }

  getDownloadUrl(): Observable<any> {
    return this.apiRequest.request('GET','/v2/trinity/quote/download/'+this.trinityUUid);
  }

  saveTrinityQuotePayload(){
    this.dataSaving = true
    this.showDataSaving = true
    this.saveTrinityQuotePayloadApiCall().subscribe((res:any) => {
      if(res && res.status){
        this.trinityQuoteSaveId = res.id || "";
        this.trinityWidgetData = res.cost_misc	|| {};

        // this.trinityWidgetData['sampling_discount'] = {"values":[5,10,15,20],"name":"Discount","action":{"type":"button","name":"Apply"},"selectedValue":5,"hideKey":"Discount"}
        // this.trinityWidgetData['professional_discount'] = {"values":[5,10,15,20],"name":"Discount","action":{"type":"button","name":"Apply"},"selectedValue":5}
        
        // this.trinityWidgetData = res.cost_misc	|| [];
        // if(res.cost_misc && res.cost_misc[0] && res.cost_misc[0].length){
        //   this.isPMFeasibilty = res.cost_misc[0].findIndex((item) => item.value == 'Sent to PM') > -1;
        // }  

        this.checkPMFeasibility(res);
        this.setTrinityQuoteSaveName(res.quote_name);
        this.setTrinityQuoteRequestId(res.tid);
        // if(res.cost_misc && res.cost_misc['overall'] && res.cost_misc['overall'].Feasibilty){
        //   this.isPMFeasibilty = res.cost_misc['overall']['Feasibilty']["value"] == 'Sent to PM' ? true : false;
        // } 

        this.dataSaving = false;
        this.tid = res.tid;
        if (!(this.trinityUUid && this.trinityUUid !="")) {
          this.trinityUUid = res.id;
          this.router.navigate(['/trinity/request/'+res.id]);
        }
      }else{
        this.notify.notify('error',res.message);
        this.dataSaving = false;
        this.showDataSaving = false
      }
    })
  }

  checkPMFeasibility(res){
    if(res.cost_misc && res.cost_misc['overall'] && res.cost_misc['overall'].Feasibilty){
          this.isPMFeasibilty = res.cost_misc['overall']['Feasibilty']["value"] == 'Sent to PM' ? true : false;
      } 
  }  
  setTrinityQuoteSaveName(name:string){
    this.trinityQuoteSaveName = name && name != "" ? name : "";
  }

  setTrinityQuoteRequestId(requestId:string){
    this.trinityQuoteRequestId = requestId;
  }

  saveTrinityQuotePayloadApiCall(): Observable<any> {
    let body = {data:this.trinityQuoteSavePayloadObject};
    if(this.trinityQuoteSaveId){
      body['id'] = this.trinityQuoteSaveId;
    }
    return this.apiRequest.request('POST','/v2/trinity/quote',body);
  }

  
  getQuoteDetails(uuid): Observable<any> {
    return this.apiRequest.request('GET','/v2/trinity/quote/'+uuid);
  }
}
